export default function showActivitiesPanel(prefix) {
  const params = this.dataGet(prefix,["id","module"]);
  this.openRightPanel("load");
  this.dsClear();
  this.dataSet("rightPanel/data", params, "ActivitiesTimelineView");
  this.reloadActivitiesPanel("rightPanel/data");
}
